import { Component, Input } from '@angular/core';

/**
 * @deprecated Neptune design system recommends skeleton loaders and discourages the use of spinning loaders.
 * Skeleton loaders are defined in the individual component templates and should be used instead of this loader component.
 */
@Component({
    selector: 'loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
    standalone: false
})
export class LoaderComponent {

  constructor() { }

  @Input() size: string = "";
  @Input() color: string = "";

  getClasses(): { [key: string]: boolean } {
    return {
      'loader-sm': this.size === 'small',
      'loader-md': this.size === 'medium',
      'loader-lg': this.size === 'large',
      'loader-reverse': this.size === 'reverse',
      'loader-white': this.color === 'white'
    };
  }
}
